import fromAnyToString from './fromAnyToString';

const fromAnyToSpacelessString = (value) => fromAnyToString(value).replace(/ /g, '');

// noinspection JSUnusedGlobalSymbols
export default fromAnyToSpacelessString;
